import React from "react";

import { Characteristic as ICharacteristic } from ".";
import { MultipleData } from "./Multiple-data/MultipleData";
import { SingleData } from "./SingleData";

interface Props extends ICharacteristic {
  viewOnly: boolean;
  subcategoryId?: number;
  hideEyeIcon?: boolean;
}

export const Characteristic: React.FC<Props> = ({ viewOnly, hideEyeIcon, subcategoryId, ...characteristic }) => {
  if (characteristic.is_multiple) {
    return <MultipleData characteristic={characteristic} viewOnly={viewOnly} hideEyeIcon={hideEyeIcon} />;
  }

  return (
    <SingleData
      characteristic={characteristic}
      viewOnly={viewOnly}
      hideEyeIcon={hideEyeIcon}
      subcategoryId={subcategoryId}
    />
  );
};
